/**
 * TAG COLOR UTILITY
 *
 * Deterministic color assignment for labels/tags based on label name hash.
 * The same label always gets the same color across sessions and users
 * for visual consistency. Used by both the header tags (App.jsx) and
 * the TestScenarioEditModal label management.
 */

// Available Atlaskit Tag colors (excluding 'standard' and 'grey'/'gray' for visual variety)
const TAG_COLORS = [
  'green', 'blue', 'teal', 'purple', 'red', 'orange',
  'yellow', 'lime', 'magenta',
  'greenLight', 'blueLight', 'tealLight', 'purpleLight', 'yellowLight'
]

/**
 * Get a deterministic Atlaskit Tag color for a given label name.
 * Uses a simple string hash so the same name always maps to the same color.
 *
 * @param {string} labelName - The label text to hash
 * @returns {string} An Atlaskit TagColor value
 */
export const getTagColor = (labelName) => {
  let hash = 0
  for (let i = 0; i < labelName.length; i++) {
    hash = labelName.charCodeAt(i) + ((hash << 5) - hash)
  }
  return TAG_COLORS[Math.abs(hash) % TAG_COLORS.length]
}

// Atlaskit Lozenge appearances for label display in scenario details header
const LOZENGE_APPEARANCES = [
  'default', 'inprogress', 'moved', 'new', 'removed', 'success'
]

/**
 * Get a deterministic Atlaskit Lozenge appearance for a given label name.
 * Used in the scenario details header where Lozenge is preferred over Tag
 * for consistent sizing with the priority field.
 *
 * @param {string} labelName - The label text to hash
 * @returns {string} An Atlaskit Lozenge appearance value
 */
export const getLabelLozengeAppearance = (labelName) => {
  let hash = 0
  for (let i = 0; i < labelName.length; i++) {
    hash = labelName.charCodeAt(i) + ((hash << 5) - hash)
  }
  return LOZENGE_APPEARANCES[Math.abs(hash) % LOZENGE_APPEARANCES.length]
}
